import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { ElementMaxHeightService } from '@common/services';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: '[appTrackHeight]',
  standalone: true
})
export class TrackHeightDirective implements AfterViewInit, OnDestroy {
  @Input('appTrackHeight') key!: string;

  constructor(
    private el: ElementRef,
    private heightService: ElementMaxHeightService
  ) {}

  ngAfterViewInit(): void {
    if (!this.key) return;

    this.heightService.updateRef(this.key, this.el.nativeElement);
  }

  ngOnDestroy(): void {
    if (!this.key) return;

    this.heightService.updateRef(this.key, null);
  }
}
